import { combineReducers } from "redux";
import authReducer from "./authReducer";
import conversationReducer from "./conversationReducer";
import searchReducer from "./searchReducer";
import navbarReducer from "./navbarReducer";
import userReducer from "./userReducer";
import documentReducer from "./documentReducer";
import { RESET_STORE } from "../actions/types"; // Import the RESET_STORE action
import messageReducer from "./messageReducer";
import contractReducer from "./contractReducer";
import signatureReducer from "./signatureReducer";
import deviceReducer from "./deviceReducer"
import newsReducer from "./newsReducer"
import boReducer from "./boReducer"
import themeReducer from "./themeReducer" // Theme reducer for light/dark mode
import chatUIReducer from "./chatUIReducer"; // Chat UI state reducer
import subscriptionReducer from "./subscriptionReducer"; // Subscription state
import pricingReducer from "./pricingReducer"; // Pricing data from API
import entreprisesReducer from "./entreprisesReducer"
import dataUpdateReducer from "./dataUpdateReducer"
import marketingReducer from "./marketingReducer"
import boConsolidationReducer from "./boConsolidationReducer"
import linkedinOutreachReducer from "./linkedinOutreachReducer"
import facturationReducer from "./facturationReducer"
import inboxReducer from "./inboxReducer"
import onboardingReducer from "../../features/onboarding/redux/onboardingSlice"

// Combine all reducers
const appReducer = combineReducers({
  auth: authReducer,
  conversations: conversationReducer,
  search: searchReducer,
  navbar: navbarReducer,
  user: userReducer,
  document: documentReducer,
  messages: messageReducer,
  contract: contractReducer,
  signature: signatureReducer,
  devices: deviceReducer,
  legalNews: newsReducer,
  bo: boReducer,
  theme: themeReducer,
  chatUI: chatUIReducer,
  subscription: subscriptionReducer,
  pricing: pricingReducer,
  entreprises: entreprisesReducer,
  dataUpdate: dataUpdateReducer,
  marketing: marketingReducer,
  boConsolidation: boConsolidationReducer,
  linkedinOutreach: linkedinOutreachReducer,
  facturation: facturationReducer,
  inbox: inboxReducer,
  onboarding: onboardingReducer,
});

// Root reducer that resets state when RESET_STORE is dispatched
const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    // Reset the entire state to undefined, triggering the initial state for all reducers
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;